import { IconButton, Typography } from '@mui/material'
import { Dismiss24Regular } from '@/components/Icon'
import styles from './integrationsModal.module.scss'

/** @param {{ onClose: () => void }} props */
export default function IntegrationsModalHeader({ onClose }) {
  return (
    <header className={styles.header}>
      <Typography id="integrations-modal-title" component="h2" className={styles.title}>
        Add Connections
      </Typography>
      <Typography component="p" className={styles.subtitle}>
        Select an existing connection for this agent or create a new one.
      </Typography>
      <IconButton
        type="button"
        aria-label="Close integrations"
        onClick={onClose}
        size="small"
        className={styles.closeButton}
      >
        <Dismiss24Regular className={styles.closeIcon} aria-hidden />
      </IconButton>
    </header>
  )
}
